import { render } from "./ContactCardComponent.vue?vue&type=template&id=50edb613&scoped=true"
import script from "./ContactCardComponent.vue?vue&type=script&lang=js"
export * from "./ContactCardComponent.vue?vue&type=script&lang=js"

import "./ContactCardComponent.vue?vue&type=style&index=0&id=50edb613&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50edb613"]])

export default __exports__